export type AttachmentLabel = "WORKFILE" | "PAYMENT_RECEIPT";

export function normalizeDocAttachmentLabel(
  raw: string | undefined | null
): AttachmentLabel {
  if (raw === "PAYMENT_RECEIPT") return "PAYMENT_RECEIPT";
  return "WORKFILE";
}

export function attachmentLabelDisplay(
  raw: string | undefined | null
): string {
  return normalizeDocAttachmentLabel(raw) === "PAYMENT_RECEIPT"
    ? "Payment receipt"
    : "Work file";
}

export function isPaymentReceiptLabel(
  raw: string | undefined | null
): boolean {
  return normalizeDocAttachmentLabel(raw) === "PAYMENT_RECEIPT";
}
